import * as React from "react";
import Menu from "src/packages/menu/Menu";
import SubMenu from "src/packages/menu/SubMenu";
import MenuItem from "src/packages/menu/MenuItem";
import { RouteComponentProps } from "react-router";

interface INavBarProps extends RouteComponentProps {
  xxx?: string;
}

interface INavBarState {
  selectedKey: string;
}

class NavBar extends React.Component<INavBarProps, INavBarState> {
  public static displayName = "NavBar";

  public state = {
    selectedKey: "introduction"
  };

  public componentDidMount() {
    const reg = /\/(\w+)$/;
    const pathname = this.props.location.pathname;
    if (reg.test(pathname)) {
      this.setState({
        selectedKey: RegExp.$1
      });
    } else {
      this.goToLink("/introduction");
    }
  }

  public componentDidUpdate(prevProps: INavBarProps, prevState: INavBarState) {
    const { selectedKey } = this.state;
    if (prevState.selectedKey !== selectedKey) {
      this.goToLink(this.getPathname(selectedKey));
    }
  }

  public goToLink = (pathname: string) => {
    const { location, history } = this.props;
    if (location.pathname !== pathname) {
      history.push(pathname);
    }
  };

  public handleSelectedChange = (key: string) => {
    const { selectedKey } = this.state;
    if (key !== selectedKey) {
      this.setState({
        selectedKey: key
      });
    }
  };

  public getPathname = (key: string) => {
    switch (key) {
      case "introduction":
      case "start":
      case "color":
      case "zindex":
        return `/${key}`;
      default:
        return `/components/${key}`;
    }
  };

  public render() {
    return (
      <aside className="aside">
        <Menu
          onSelectedChange={this.handleSelectedChange}
          selectedKey={this.state.selectedKey}
          style={{ width: "275px", borderRight: "none" }}
          defaultExpandKeys={["components"]}
        >
          <MenuItem key="introduction" style={{ fontWeight: 600 }}>
            Xue-react
          </MenuItem>
          <MenuItem key="start" style={{ fontWeight: 500 }}>
            开始使用
          </MenuItem>
          <MenuItem key="color" style={{ fontWeight: 500 }}>
            色彩搭配
          </MenuItem>
          <MenuItem key="zindex" style={{ fontWeight: 500 }}>
            层级规范
          </MenuItem>
          <SubMenu
            key="components"
            title={<div className="nav-bar-components-title">Components</div>}
            showArrow={false}
            itemGroup={true}
          >
            <SubMenu
              key="common"
              title="通用"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="button">Button&nbsp;&nbsp;按钮</MenuItem>
            </SubMenu>
            <SubMenu
              key="layout"
              title="布局"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="grid">Grid&nbsp;&nbsp;栅格</MenuItem>
              {/* <MenuItem key="waterfall">Waterfall&nbsp;&nbsp;瀑布流</MenuItem> */}
            </SubMenu>
            <SubMenu
              key="navigation"
              title="导航"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="affix">Affix&nbsp;&nbsp;固钉</MenuItem>
              <MenuItem key="menu">Menu&nbsp;&nbsp;导航菜单</MenuItem>
              <MenuItem key="pager">Pager&nbsp;&nbsp;分页</MenuItem>
            </SubMenu>
            <SubMenu
              key="dataentry"
              title="数据录入"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="cascader">Cascader&nbsp;&nbsp;级联选择</MenuItem>
              <MenuItem key="checkbox">CheckBox&nbsp;&nbsp;选择框</MenuItem>
              <MenuItem key="datepicker">
                DatePicker&nbsp;&nbsp;日期选择
              </MenuItem>
              <MenuItem key="input">Input&nbsp;&nbsp;输入框</MenuItem>
              <MenuItem key="radio">Radio&nbsp;&nbsp;单选框</MenuItem>
              <MenuItem key="rate">Rate&nbsp;&nbsp;评分</MenuItem>
              <MenuItem key="switch">Switch&nbsp;&nbsp;开关</MenuItem>
            </SubMenu>
            <SubMenu
              key="datadisplay"
              title="数据展示"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="collapse">Collapse&nbsp;&nbsp;折叠面板</MenuItem>
              <MenuItem key="popover">Popover&nbsp;&nbsp;气泡卡片</MenuItem>
              <MenuItem key="slides">Slides&nbsp;&nbsp;轮播</MenuItem>
              <MenuItem key="table">Table&nbsp;&nbsp;表格</MenuItem>
              {/* <MenuItem key="virtualtable">VirtualTable&nbsp;&nbsp;虚拟表格</MenuItem> */}
              <MenuItem key="tabs">Tabs&nbsp;&nbsp;标签</MenuItem>
            </SubMenu>
            <SubMenu
              key="feedback"
              title="信息反馈"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="message">Message&nbsp;&nbsp;全局提示</MenuItem>
              <MenuItem key="modal">Modal&nbsp;&nbsp;对话框</MenuItem>
              <MenuItem key="spin">Spin&nbsp;&nbsp;加载中</MenuItem>
            </SubMenu>
            <SubMenu
              key="others"
              title="其他"
              showArrow={false}
              itemGroup={true}
            >
              <MenuItem key="lightup">LightUp&nbsp;&nbsp;图片预览</MenuItem>
              <MenuItem key="scroll">Scroll&nbsp;&nbsp;滚动条</MenuItem>
              <MenuItem key="transition">Transition&nbsp;&nbsp;过渡</MenuItem>
            </SubMenu>
          </SubMenu>
        </Menu>
      </aside>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.tsx